import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Button from './Button';

const HeroSlider = ({
  slides = [
    {
      image: '/images/hero/slider-main.jpg',
      title: 'WELCOME TO MIRAGE DESSERTS',
      subtitle: 'Quality, Expertise and Reliability',
      primaryButton: { label: 'Services', href: '/pastry-mixes' },
      secondaryButton: { label: 'Contact', href: '/contact-us' }
    }
  ]
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const slide = slides[currentSlide];

  return (
    <div className="relative h-[600px] md:h-[700px] overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${slide.image})` }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center text-center px-6">
        <div className="max-w-4xl">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-4 tracking-wide">
            {slide.title}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8">
            {slide.subtitle}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {slide.primaryButton && (
              <Button href={slide.primaryButton.href} variant="filled">
                {slide.primaryButton.label}
              </Button>
            )}
            {slide.secondaryButton && (
              <Button href={slide.secondaryButton.href} variant="outlined" className="border-white text-white hover:bg-white hover:text-primary-red">
                {slide.secondaryButton.label}
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      {slides.length > 1 && (
        <>
          <button
            onClick={goToPrevious}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 p-3 rounded-full transition-colors"
            aria-label="Previous slide"
          >
            <ChevronLeft size={24} className="text-white" />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/40 p-3 rounded-full transition-colors"
            aria-label="Next slide"
          >
            <ChevronRight size={24} className="text-white" />
          </button>
        </>
      )}

      {/* Dots */}
      {slides.length > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HeroSlider;
